import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useUser, useLang, useTrkptsWS, useSessionWS } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'

import CreateEmail from '../components/CreateEmail'
import CheckCode from '../components/CheckCode'
import CreateUserName from '../components/CreateUserName'
import CreatePwd from '../components/CreatePwd'
import Subscribe from '../components/Subscribe'
import LoginBox from '../components/LoginBox'
import UserCreated from '../components/UserCreated'
import Footer from '../components/Footer'

import {
  noAccount,
  freeAccount,
  subscribeAccount,
  oldSubscribeAccount,
} from '../assets/accounts'
import { useRef } from 'react'

const Login = () => {
  const navigate = useNavigate()

  const firstDiv = useRef(null)

  const { user, changeUser } = useUser()
  const { lang } = useLang()
  const { changeTrkptsWS } = useTrkptsWS()
  const { changeSessionWS } = useSessionWS()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  const [email, setEmail] = useState('')
  const [pwd, setPwd] = useState('')
  const [emailOK, setEmailOK] = useState(false)
  const [pwdOK, setPwdOK] = useState('')
  const [subscribeOK, setSubscribeOK] = useState(-1)
  const [badEntries, setBadEntries] = useState(false)
  const [code, setCode] = useState()
  const [codeId, setCodeId] = useState(null)

  const [showCreateNotif, setShowCreateNotif] = useState('hide')

  const [doCreateCompte, setDoCreateCompte] = useState(false)
  const [doSubscribe, setDoSubscribe] = useState(false)
  const [createEmail, setCreateEmail] = useState('')
  const [createPwd, setCreatePwd] = useState('')
  const [createUserName, setCreateUserName] = useState('')
  const [createEmailOK, setCreateEmailOK] = useState(false)
  const [createEmailNotUsed, setCreateEmailNotUsed] = useState(true)
  const [createUSerCodeExact, setCreateUserCodeExact] = useState(true)
  const [createUserCodeOK, setCreateUserCodeOK] = useState(false)
  const [createUserNameOK, setCreateUserNameOK] = useState(false)
  const [createPwdOK, setCreatePwdOK] = useState(false)
  const [userCreated, setUserCreated] = useState(-1)

  const [pwdLost, setPwdLost] = useState(false)
  const [pwdLostEmailExist, setPwdLostEmailExist] = useState(-1)
  const [pwdLostReplaced, setPwdLostReplaced] = useState(false)

  const today = new Date()

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
  }

  const callApiLogin = async () => {
    // let url
    // switch (db) {
    //   case 'local':
    //   case 'ovh':
    //     url = '/api/auth/login'
    //     break
    //   case 'mongo':
    //     url = '/api/authMD/login'
    //     break
    //   default:
    // }

    const url = '/api/authMD/login'

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        pwd,
      }),
    })
      .then((response) => {
        response.json().then((data) => {
          if (data.error) {
            setBadEntries(true)

            changeUser({
              userName: '',
              userId: -1,
              accountType: noAccount,
              subscribeStart: 0,
              subscribeEnd: 0,
            })
            localStorage.setItem('wsurf_userName', '')
            localStorage.setItem('wsurf_userId', '-1')
            localStorage.setItem('wsurf_subscribeAccount', noAccount)
            localStorage.setItem('wsurf_subscribeStart', '')
            localStorage.setItem('wsurf_subscribeEnd', '')
          } else {
            setBadEntries(false)
            const start = data.subscribeDate
              ? new Date(data.subscribeDate)
              : null
            let end = data.subscribeDate ? new Date(data.subscribeDate) : null
            if (end) end.setMonth(end.getMonth() + Number(data.subscribeLength))

            const tempAccount = end
              ? end > today
                ? subscribeAccount
                : oldSubscribeAccount
              : freeAccount
            changeUser({
              userName: data.userName,
              userId: data.userId,
              accountType: tempAccount,
              subscribeStart: start,
              subscribeEnd: end,
            })
            localStorage.setItem('wsurf_userName', data.userName)
            localStorage.setItem('wsurf_userId', data.userId)
            localStorage.setItem('wsurf_accountType', tempAccount)
            localStorage.setItem('wsurf_subscribeStart', start)
            localStorage.setItem('wsurf_subscribeEnd', end)
            document.cookie = 'ws2=' + data.token
            navigate(`/sessions/`)
          }
        })
      })
      .catch((error) => console.log(error))
  }

  const callApiDeleteCode = async () => {
    const url_code = '/api/code/deleteCode'
    fetch(url_code, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        codeId: codeId,
      }),
    })
      .then((response) => {
        response.json().then(() => {
          //setCode()
          setCodeId(null)
        })
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    changeTrkptsWS({ brut: [], origin: '' })
    changeSessionWS(null)
  }, [])

  useEffect(() => {
    const callApiCheckEmailExists = () => {
      // let url
      // switch (db) {
      //   case 'local':
      //   case 'ovh':
      //     url = '/api/auth/login'
      //     break
      //   case 'mongo':
      //     url = '/api/authMD/checkEmailExists'
      //     break
      //   default:
      // }
      const url = '/api/authMD/checkEmailExists'
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: createEmail,
        }),
      })
        .then((response) => {
          response.json().then((data) => {
            if (data.message) {
              if (
                (data.message === 'no_user' && pwdLost === false) ||
                (data.message !== 'no_user' && pwdLost === true)
              ) {
                setCreateEmailOK(true)
                setPwdLostEmailExist(1)
                const url_code = '/api/code/setCode'
                fetch(url_code, {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    email: createEmail,
                    what: pwdLost === true ? 'lost' : 'new',
                    lang: lang,
                  }),
                })
                  .then((response) => {
                    response.json().then((data) => {
                      const temp_codeId = data.id
                      //const temp_code = data.code
                      //setCode(temp_code)
                      setCodeId(temp_codeId)
                    })
                  })
                  .catch((error) => console.log(error))
              } else if (data.message === 'no_user' && pwdLost === true) {
                setPwdLostEmailExist(0)
                //
              } else {
                setCreateEmail('')
                setCreateEmailNotUsed(false)
              }
            }
          })
        })
        .catch((error) => console.log(error))
    }
    if (createEmail !== '') callApiCheckEmailExists()
  }, [createEmail])

  useEffect(() => {
    const callApiSignUp = async () => {
      // let url
      // switch (db) {
      //   case 'local':
      //   case 'ovh':
      //     url = '/api/auth/signup'
      //     break
      //   case 'mongo':
      //     url = '/api/authMD/signup'
      //     break
      //   default:
      // }
      const url = '/api/authMD/signup'
      const creationDate = new Date()
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: createEmail,
          pwd: createPwd,
          userName: createUserName,
          creationDate: creationDate,
          subscribeDate: subscribeOK === 1 ? creationDate : null,
          subscribeLength:
            subscribeOK === 1
              ? process.env.REACT_APP_SUBSCRIBE_LENGTH_MONTHS
              : 0,
        }),
      })
        .then((response) => {
          response.json().then((data) => {
            if (data.message) {
              if (data.message === 'utilisateur créé') {
                setUserCreated(1)
              } else {
                setUserCreated(0)
              }
            }
          })
        })
        .catch((error) => console.log(error))
    }

    if (
      createPwdOK &&
      (subscribeOK === 1 ||
        (doSubscribe === false && subscribeOK === -1 && pwdLost === false))
    )
      callApiSignUp()
  }, [
    createPwdOK,
    createEmail,
    createPwd,
    createUserName,
    subscribeOK,

    pwdLost,
  ])

  useEffect(() => {
    const callApiUpdatePwd = async () => {
      if (createPwdOK === false) return

      const url = '/api/authMD/updatePwdLost'
      const data = { email: createEmail, pwd: createPwd }

      fetch(url, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log('pwd modifié')
          setCreatePwd('')
          setPwdLostReplaced(true)
        })
        .catch((error) => console.log(error))
    }

    if (createPwdOK === true && pwdLost === true && pwdLostEmailExist === 1)
      callApiUpdatePwd()
  }, [createPwdOK, createEmail, pwdLost, pwdLostEmailExist])

  const onEmailChange = (value) => {
    const temp_email = value
    setEmail(temp_email)
    setEmailOK(validateEmail(temp_email))
  }

  const onPwdChange = (value) => {
    const temp_pwd = value
    setPwd(temp_pwd)
    setPwdOK(temp_pwd.length > 5)
  }

  const onPwdLost = () => {
    setPwdLost(true)
  }

  const onSubmit = () => {
    callApiLogin()
  }

  const onStartCreateCompte = () => {
    setShowCreateNotif('create')
    setDoCreateCompte(true)
  }

  const onStartSubscribe = () => {
    setShowCreateNotif('subscribe')
    setDoCreateCompte(true)
    setDoSubscribe(true)
  }

  const onConfirmSubscribe = (isOk) => {
    setDoSubscribe(false)
    setSubscribeOK(isOk)
  }

  const onCancel = () => {
    setEmail('')
    setPwd('')
    setEmailOK(false)
    setPwdOK('')
    setBadEntries(false)
    //setCode()
    if (codeId) callApiDeleteCode()

    setDoCreateCompte(false)
    setDoSubscribe(false)
    setCreateEmail('')
    setCreatePwd('')
    setCreateUserName('')
    setCreateEmailOK(false)
    setCreateEmailNotUsed(true)
    setCreateUserCodeExact(true)
    setCreateUserCodeOK(false)
    setCreateUserNameOK(false)
    setCreatePwdOK(false)
    setUserCreated(-1)
    setShowCreateNotif('hide')
    setSubscribeOK(-1)

    setPwdLost(false)
    setPwdLostEmailExist(-1)
  }

  const onConfirmEmail = (temp_email) => {
    setCreateEmail(temp_email)
  }

  const onConfirmCode = (temp_code) => {
    const url = '/api/code/verifyCode'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: codeId,
        code: temp_code,
      }),
    })
      .then((response) => {
        response.json().then((data) => {
          if (data.verify === true) {
            setCreateUserCodeOK(true)
            callApiDeleteCode()
          } else {
            setCreateUserCodeOK(false)
            setCreateUserCodeExact(false)
          }
        })
      })
      .catch((error) => console.log(error))

    // if (Number(temp_code) === code) {
    //   setCreateUserCodeOK(true)
    // } else {
    //   setCreateUserCodeOK(false)
    //   setCreateUserCodeExact(false)
    // }
  }
  const onConfirmUserName = (temp_user_name) => {
    setCreateUserName(temp_user_name)
    setCreateUserNameOK(true)
  }
  const onConfirmPwd = (temp_pwd) => {
    setCreatePwd(temp_pwd)
    setCreatePwdOK(true)
  }

  return (
    <>
      <section className="section" ref={firstDiv}>
        <div className="columns">
          <div className="column is-one-third is-offset-1">
            <div className="content">
              <h3 className="is-size-5-mobile">{choosenLang.signedUp}</h3>
            </div>
            <LoginBox
              badEntries={badEntries}
              emailOK={emailOK}
              email={email}
              onEmailChange={onEmailChange}
              pwdOK={pwdOK}
              pwd={pwd}
              onPwdChange={onPwdChange}
              onSubmit={onSubmit}
              onPwdLost={onPwdLost}
            />
          </div>
          <div className="column is-2"></div>
          <div className="column is-one-third">
            <div className="content">
              {doCreateCompte === false && pwdLost === false && (
                <h3 className="is-size-5-mobile">{choosenLang.firstVisit}</h3>
              )}
              {doCreateCompte === false &&
                pwdLost === true &&
                pwdLostReplaced === false && (
                  <h3 className="is-size-5-mobile">{choosenLang.pwdLost}</h3>
                )}
              {doCreateCompte === true && (
                <h4
                  className={
                    'notification is-size-5-mobile ' +
                    (doSubscribe === true && subscribeOK === -1
                      ? 'is-info is-light'
                      : doSubscribe === false &&
                        subscribeOK === -1 &&
                        !createPwdOK
                      ? 'is-alert is-light'
                      : 'is-white')
                  }
                >
                  {doSubscribe === true
                    ? choosenLang.subscribeTitle
                    : subscribeOK === -1 && !createPwdOK
                    ? choosenLang.createTitle
                    : ''}
                </h4>
              )}
              {doCreateCompte === false && pwdLost === false && (
                <div>
                  <div className="buttons">
                    <button
                      className="button is-primary is-outlined"
                      onClick={onStartCreateCompte}
                      onMouseEnter={() => setShowCreateNotif('create')}
                      onMouseLeave={() => setShowCreateNotif('hide')}
                    >
                      {choosenLang.create}
                    </button>

                    <button
                      className="button is-info is-outlined"
                      onClick={onStartSubscribe}
                      onMouseEnter={() => setShowCreateNotif('subscribe')}
                      onMouseLeave={() => setShowCreateNotif('hide')}
                    >
                      {choosenLang.subscribe}
                    </button>
                  </div>
                  {showCreateNotif !== 'hide' && (
                    <div
                      className={
                        'notification is-size-5-mobile ' +
                        (showCreateNotif === 'subscribe'
                          ? 'is-info is-light'
                          : '')
                      }
                    >
                      {showCreateNotif === 'create'
                        ? choosenLang.createDetail
                        : choosenLang.subscribeDetail}
                    </div>
                  )}
                </div>
              )}
              {doCreateCompte === true &&
                createEmailOK === false &&
                showCreateNotif !== 'hide' && (
                  <div
                    className={
                      'notification ' +
                      (showCreateNotif === 'subscribe'
                        ? 'is-info is-light'
                        : '')
                    }
                  >
                    {showCreateNotif === 'create'
                      ? choosenLang.createDetail
                      : choosenLang.subscribeDetail}
                  </div>
                )}
              {((doCreateCompte === true && createEmailOK === false) ||
                (pwdLost === true && pwdLostEmailExist !== 1)) && (
                <CreateEmail
                  doSubscribe={doSubscribe}
                  emailNotUsed={createEmailNotUsed}
                  onConfirmEmail={onConfirmEmail}
                  title={
                    pwdLost === false
                      ? choosenLang.setAddress
                      : choosenLang.setPwdLostAddress
                  }
                  showCGU={pwdLost !== true}
                  pwdLostEmailExist={pwdLostEmailExist}
                  onCancel={onCancel}
                />
              )}
              {/* {doCreateCompte === false &&
                pwdLost === true &&
                createEmailOK === false && (
                  <CreateEmail
                    doSubscribe={doSubscribe}
                    emailNotUsed={createEmailNotUsed}
                    onConfirmEmail={onConfirmEmail}
                    title={choosenLang.setPwdLostAddress}
                    showCGU={false}
                    pwdLost={pwdLost}
                    onCancel={onCancel}
                  />
                )}
              {pwdLost === true && pwdLostEmailExist === 0 && (
                <PwdLostNoEmail />
              )} */}
              {((createEmailOK === true && createUserCodeOK === false) ||
                (pwdLost === true &&
                  createUserCodeOK === false &&
                  pwdLostEmailExist === 1)) && (
                <CheckCode
                  doSubscribe={doSubscribe}
                  codeExact={createUSerCodeExact}
                  onConfirmCode={onConfirmCode}
                  mail={createEmail}
                  read_code={code}
                  onCancel={onCancel}
                />
              )}
              {/* userName création compte */}
              {createUserCodeOK === true &&
                createUserNameOK === false &&
                pwdLost === false && (
                  <CreateUserName
                    doSubscribe={doSubscribe}
                    onConfirmUserName={onConfirmUserName}
                    onCancel={onCancel}
                    title={choosenLang.setUser}
                  />
                )}
              {/* pwd création compte */}
              {(createUserNameOK === true ||
                (createUserCodeOK === true &&
                  pwdLost === true &&
                  pwdLostEmailExist === 1)) &&
                createPwdOK === false && (
                  <CreatePwd
                    doSubscribe={doSubscribe}
                    onConfirmPwd={onConfirmPwd}
                    onCancel={onCancel}
                    title={
                      pwdLost === false
                        ? choosenLang.setPwd
                        : choosenLang.setNewPwd
                    }
                  />
                )}
              {/* paypal si abo */}
              {createPwdOK === true &&
                doSubscribe === true &&
                subscribeOK === -1 && (
                  <Subscribe
                    doSubscribe={doSubscribe}
                    onConfirmSubscribe={onConfirmSubscribe}
                    onCancel={onCancel}
                  />
                )}
              {/* pwd création compte */}
              {createPwdOK === true && doSubscribe === false && (
                <UserCreated
                  ok={userCreated}
                  subscribeOk={subscribeOK}
                  pwdLostReplaced={pwdLostReplaced}
                  creationDidFail={onCancel}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Login
